import React from 'react'
import { Navigate } from 'react-router-dom';

function Checkout() {
  const token=localStorage.getItem('token');

  if(!token){
    return <Navigate to='/login'/>
  }
  
  return (
    <div>
      checkout
    </div>
  )
}

export default Checkout
